import { Component, OnInit } from '@angular/core';
import { cardsQrisly } from 'src/app/constants/dashboard.const';
import { DashboardCard } from 'src/app/models/dashboard.model';
import { GENERATE_LIMIT } from 'src/app/constants/endpoint.const';
import { NzMessageService } from 'ng-zorro-antd/message';
import { BaseService } from 'src/app/services/base.service';

@Component({
  standalone: false,
  selector: 'app-qrisly-stat',
  templateUrl: './qrisly-stat.component.html',
  styleUrl: './qrisly-stat.component.scss'
})
export class QrislyStatComponent implements OnInit {
loading: boolean = true;
cardsQrisly: DashboardCard[] = cardsQrisly;

constructor(
  public baseService: BaseService,
  private message: NzMessageService,
) {}

ngOnInit(): void {
  this.getQrislyStat();
}

getQrislyStat() {
  this.loading = true;
  this.baseService.getData(GENERATE_LIMIT).subscribe(
    (res: {data: {total_generated: number, total_amount: number}}) => {
      this.cardsQrisly[0].value = res.data.total_generated || 0;
      this.cardsQrisly[1].value = res.data.total_amount || 0;
    },
    (error) => {
      this.message.error(error.error.meta.message);
    },
    () => {
      this.loading = false;
    }
  );
}

}
